import styled from "styled-components";

const PageHeader = styled.h1`
  color: rgba(0, 0, 0, 0.7);
  margin: 0;
`;

export default PageHeader;
